
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.188 4c6.337.093 11.62 5.29 11.813 11.625.005.143 0 .274 0 .406-.012 3.289-2.716 5.97-6 5.969-1.271-.001-2.391-.628-3.125-1.563-.827.948-2.027 1.563-3.375 1.563a4.516 4.516 0 01-4.5-4.5v-3c0-2.473 2.027-4.5 4.5-4.5.928 0 1.781.295 2.5.781V10h2v8c0 1.116.883 1.999 2 2a3.983 3.983 0 004-3.969c0-.122.003-.231 0-.344-.16-5.253-4.589-9.61-9.844-9.688-6.165-.09-11.048 5.348-10 11.719.696 4.234 4.182 7.613 8.438 8.188 2.919.394 5.61-.452 7.656-2.094l1.25 1.563c-2.452 1.968-5.691 2.968-9.156 2.5-5.139-.694-9.346-4.723-10.188-9.844C2.915 10.486 8.823 3.892 16.188 4zm-.688 8a2.484 2.484 0 00-2.5 2.5v3c0 1.393 1.107 2.5 2.5 2.5s2.5-1.107 2.5-2.5v-3c0-1.393-1.107-2.5-2.5-2.5z"}})])
          )
        }
      }
    